import { topBarTemplate, TopBarComponent } from './TopBar';
import styles from './TopBar.styles.scss';
export const topBarDefinition = {
    baseName: 'top-bar',
    template: topBarTemplate,
    styles,
};
export const chameleonTopBar = TopBarComponent.compose(topBarDefinition);
